export enum RenderOrderEnum {
    Default = 0,
    Products = 50,
    Annotation2d = 100,
    ReferenceLine = 200,
    Drawable = 300,
    RoomNames = 400,
}